import { motion } from "framer-motion";
import slogo from "../assets/images/spare_logo_title.PNG";

export default function LoadingComponent() {
    return (
        <div>
            <motion.img
                alt="Spare"
                src={slogo}
                animate={{
                    scale: [0.25, 0.25, 0.5, 0.5, 0.25],
                    rotate: [0, 180, 180, 180, 0]
                }}
            />
        </div>
    )
}